import Model from '@models/Model'

export const TYPE_PRIVATE = 'PRIVATE'
export const TYPE_LEGAL = 'LEGAL'

export const TYPES = {
  [TYPE_PRIVATE]: 'private',
  [TYPE_LEGAL]: 'legal'
}

export default class Profile extends Model {
  get private () {
    return this.$model.type === TYPE_PRIVATE
  }

  get typeLabel () {
    return TYPES[this.$model.type]
  }

  get largePicture () {
    return this.$model.largePicture
  }

  getSchema () {
    return {
      'id': {
        type: String
      },
      'name': {
        type: String
      },
      'type': {
        type: String,
        default: TYPE_PRIVATE
      },
      'current': {
        type: Boolean
      },
      'largePicture': {
        type: String
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Profile/model.js